export default __webpack_public_path__ + "static/media/mlbFantasyPWRSmobileDark.396c6df1.png";